import React from 'react';
import { ReminderSettings } from 'types/calendarSetting';
import { fetchReminderSettings } from 'api/calendarSetting';


const useCalendarConfigSetting = (): [ReminderSettings | undefined, boolean, (id?: number) => void] => {
    const loading = React.useRef(false);
    const [data, setData] = React.useState<ReminderSettings>();
    const fetchData = async (id?: number) => {
        if (loading.current) {
            return;
        }
        try {
            loading.current = true;
            const _data = await fetchReminderSettings();
            if (_data?.data?.data) {
                setData(_data.data.data);
            }
            loading.current = false;
        } catch (e) {
            console.error(e);
            loading.current = false;
        }
    };
    React.useEffect(() => {
        fetchData();
    }, []);

    return [data, loading.current, fetchData];
};

export default useCalendarConfigSetting;
